exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-select .vs__dropdown-menu[data-v-5673bcd0] {\n  position: absolute !important;\n  z-index: 1000 !important;\n}\n.vx-card[data-v-5673bcd0] {\n  position: relative;\n}\r\n", ""]);

// exports
